/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as ShippingRouteImport } from "./routes/shipping";
import { Route as PaymentRouteImport } from "./routes/payment";
import { Route as CartRouteImport } from "./routes/cart";
import { Route as AdminRouteImport } from "./routes/admin";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as OrderConfirmationOrderIdRouteImport } from "./routes/order-confirmation.$orderId";
import { Route as AdminLoginRouteImport } from "./routes/admin_.login";
import { Route as AdminShippingCredentialsRouteImport } from "./routes/admin/shipping-credentials";
import { Route as AdminShippingRouteImport } from "./routes/admin/shipping";
import { Route as AdminSettingsRouteImport } from "./routes/admin/settings";
import { Route as AdminLokacijeRouteImport } from "./routes/admin/lokacije";
import { Route as AdminEmailsRouteImport } from "./routes/admin/emails";
import { Route as AdminDashboardRouteImport } from "./routes/admin/dashboard";
import { Route as AdminCategoriesRouteImport } from "./routes/admin/categories";
import { Route as AdminProductsIndexRouteImport } from "./routes/admin/products.index";
import { Route as AdminOrdersIndexRouteImport } from "./routes/admin/orders.index";
import { Route as AdminProductsNewRouteImport } from "./routes/admin/products.new";
import { Route as AdminOrdersIdRouteImport } from "./routes/admin/orders.$id";
import { Route as AdminProductsIdEditRouteImport } from "./routes/admin/products.$id.edit";

const ShippingRoute = ShippingRouteImport.update({
  id: "/shipping",
  path: "/shipping",
  getParentRoute: () => rootRouteImport,
} as any);
const PaymentRoute = PaymentRouteImport.update({
  id: "/payment",
  path: "/payment",
  getParentRoute: () => rootRouteImport,
} as any);
const CartRoute = CartRouteImport.update({
  id: "/cart",
  path: "/cart",
  getParentRoute: () => rootRouteImport,
} as any);
const AdminRoute = AdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const OrderConfirmationOrderIdRoute =
  OrderConfirmationOrderIdRouteImport.update({
    id: "/order-confirmation/$orderId",
    path: "/order-confirmation/$orderId",
    getParentRoute: () => rootRouteImport,
  } as any);
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: "/admin_/login",
  path: "/admin/login",
  getParentRoute: () => rootRouteImport,
} as any);
const AdminShippingCredentialsRoute =
  AdminShippingCredentialsRouteImport.update({
    id: "/shipping-credentials",
    path: "/shipping-credentials",
    getParentRoute: () => AdminRoute,
  } as any);
const AdminShippingRoute = AdminShippingRouteImport.update({
  id: "/shipping",
  path: "/shipping",
  getParentRoute: () => AdminRoute,
} as any);
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AdminRoute,
} as any);
const AdminLokacijeRoute = AdminLokacijeRouteImport.update({
  id: "/lokacije",
  path: "/lokacije",
  getParentRoute: () => AdminRoute,
} as any);
const AdminEmailsRoute = AdminEmailsRouteImport.update({
  id: "/emails",
  path: "/emails",
  getParentRoute: () => AdminRoute,
} as any);
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AdminRoute,
} as any);
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
  id: "/categories",
  path: "/categories",
  getParentRoute: () => AdminRoute,
} as any);
const AdminProductsIndexRoute = AdminProductsIndexRouteImport.update({
  id: "/products/",
  path: "/products/",
  getParentRoute: () => AdminRoute,
} as any);
const AdminOrdersIndexRoute = AdminOrdersIndexRouteImport.update({
  id: "/orders/",
  path: "/orders/",
  getParentRoute: () => AdminRoute,
} as any);
const AdminProductsNewRoute = AdminProductsNewRouteImport.update({
  id: "/products/new",
  path: "/products/new",
  getParentRoute: () => AdminRoute,
} as any);
const AdminOrdersIdRoute = AdminOrdersIdRouteImport.update({
  id: "/orders/$id",
  path: "/orders/$id",
  getParentRoute: () => AdminRoute,
} as any);
const AdminProductsIdEditRoute = AdminProductsIdEditRouteImport.update({
  id: "/products/$id/edit",
  path: "/products/$id/edit",
  getParentRoute: () => AdminRoute,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/admin": typeof AdminRouteWithChildren;
  "/cart": typeof CartRoute;
  "/payment": typeof PaymentRoute;
  "/shipping": typeof ShippingRoute;
  "/admin/categories": typeof AdminCategoriesRoute;
  "/admin/dashboard": typeof AdminDashboardRoute;
  "/admin/emails": typeof AdminEmailsRoute;
  "/admin/lokacije": typeof AdminLokacijeRoute;
  "/admin/settings": typeof AdminSettingsRoute;
  "/admin/shipping": typeof AdminShippingRoute;
  "/admin/shipping-credentials": typeof AdminShippingCredentialsRoute;
  "/admin/login": typeof AdminLoginRoute;
  "/order-confirmation/$orderId": typeof OrderConfirmationOrderIdRoute;
  "/admin/orders/$id": typeof AdminOrdersIdRoute;
  "/admin/products/new": typeof AdminProductsNewRoute;
  "/admin/orders/": typeof AdminOrdersIndexRoute;
  "/admin/products/": typeof AdminProductsIndexRoute;
  "/admin/products/$id/edit": typeof AdminProductsIdEditRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/admin": typeof AdminRouteWithChildren;
  "/cart": typeof CartRoute;
  "/payment": typeof PaymentRoute;
  "/shipping": typeof ShippingRoute;
  "/admin/categories": typeof AdminCategoriesRoute;
  "/admin/dashboard": typeof AdminDashboardRoute;
  "/admin/emails": typeof AdminEmailsRoute;
  "/admin/lokacije": typeof AdminLokacijeRoute;
  "/admin/settings": typeof AdminSettingsRoute;
  "/admin/shipping": typeof AdminShippingRoute;
  "/admin/shipping-credentials": typeof AdminShippingCredentialsRoute;
  "/admin/login": typeof AdminLoginRoute;
  "/order-confirmation/$orderId": typeof OrderConfirmationOrderIdRoute;
  "/admin/orders/$id": typeof AdminOrdersIdRoute;
  "/admin/products/new": typeof AdminProductsNewRoute;
  "/admin/orders": typeof AdminOrdersIndexRoute;
  "/admin/products": typeof AdminProductsIndexRoute;
  "/admin/products/$id/edit": typeof AdminProductsIdEditRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/admin": typeof AdminRouteWithChildren;
  "/cart": typeof CartRoute;
  "/payment": typeof PaymentRoute;
  "/shipping": typeof ShippingRoute;
  "/admin/categories": typeof AdminCategoriesRoute;
  "/admin/dashboard": typeof AdminDashboardRoute;
  "/admin/emails": typeof AdminEmailsRoute;
  "/admin/lokacije": typeof AdminLokacijeRoute;
  "/admin/settings": typeof AdminSettingsRoute;
  "/admin/shipping": typeof AdminShippingRoute;
  "/admin/shipping-credentials": typeof AdminShippingCredentialsRoute;
  "/admin_/login": typeof AdminLoginRoute;
  "/order-confirmation/$orderId": typeof OrderConfirmationOrderIdRoute;
  "/admin/orders/$id": typeof AdminOrdersIdRoute;
  "/admin/products/new": typeof AdminProductsNewRoute;
  "/admin/orders/": typeof AdminOrdersIndexRoute;
  "/admin/products/": typeof AdminProductsIndexRoute;
  "/admin/products/$id/edit": typeof AdminProductsIdEditRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/admin"
    | "/cart"
    | "/payment"
    | "/shipping"
    | "/admin/categories"
    | "/admin/dashboard"
    | "/admin/emails"
    | "/admin/lokacije"
    | "/admin/settings"
    | "/admin/shipping"
    | "/admin/shipping-credentials"
    | "/admin/login"
    | "/order-confirmation/$orderId"
    | "/admin/orders/$id"
    | "/admin/products/new"
    | "/admin/orders/"
    | "/admin/products/"
    | "/admin/products/$id/edit";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/admin"
    | "/cart"
    | "/payment"
    | "/shipping"
    | "/admin/categories"
    | "/admin/dashboard"
    | "/admin/emails"
    | "/admin/lokacije"
    | "/admin/settings"
    | "/admin/shipping"
    | "/admin/shipping-credentials"
    | "/admin/login"
    | "/order-confirmation/$orderId"
    | "/admin/orders/$id"
    | "/admin/products/new"
    | "/admin/orders"
    | "/admin/products"
    | "/admin/products/$id/edit";
  id:
    | "__root__"
    | "/"
    | "/admin"
    | "/cart"
    | "/payment"
    | "/shipping"
    | "/admin/categories"
    | "/admin/dashboard"
    | "/admin/emails"
    | "/admin/lokacije"
    | "/admin/settings"
    | "/admin/shipping"
    | "/admin/shipping-credentials"
    | "/admin_/login"
    | "/order-confirmation/$orderId"
    | "/admin/orders/$id"
    | "/admin/products/new"
    | "/admin/orders/"
    | "/admin/products/"
    | "/admin/products/$id/edit";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AdminRoute: typeof AdminRouteWithChildren;
  CartRoute: typeof CartRoute;
  PaymentRoute: typeof PaymentRoute;
  ShippingRoute: typeof ShippingRoute;
  AdminLoginRoute: typeof AdminLoginRoute;
  OrderConfirmationOrderIdRoute: typeof OrderConfirmationOrderIdRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/shipping": {
      id: "/shipping";
      path: "/shipping";
      fullPath: "/shipping";
      preLoaderRoute: typeof ShippingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/payment": {
      id: "/payment";
      path: "/payment";
      fullPath: "/payment";
      preLoaderRoute: typeof PaymentRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/cart": {
      id: "/cart";
      path: "/cart";
      fullPath: "/cart";
      preLoaderRoute: typeof CartRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin": {
      id: "/admin";
      path: "/admin";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/order-confirmation/$orderId": {
      id: "/order-confirmation/$orderId";
      path: "/order-confirmation/$orderId";
      fullPath: "/order-confirmation/$orderId";
      preLoaderRoute: typeof OrderConfirmationOrderIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin_/login": {
      id: "/admin_/login";
      path: "/admin/login";
      fullPath: "/admin/login";
      preLoaderRoute: typeof AdminLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin/shipping-credentials": {
      id: "/admin/shipping-credentials";
      path: "/shipping-credentials";
      fullPath: "/admin/shipping-credentials";
      preLoaderRoute: typeof AdminShippingCredentialsRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/admin/shipping": {
      id: "/admin/shipping";
      path: "/shipping";
      fullPath: "/admin/shipping";
      preLoaderRoute: typeof AdminShippingRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/admin/settings": {
      id: "/admin/settings";
      path: "/settings";
      fullPath: "/admin/settings";
      preLoaderRoute: typeof AdminSettingsRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/admin/lokacije": {
      id: "/admin/lokacije";
      path: "/lokacije";
      fullPath: "/admin/lokacije";
      preLoaderRoute: typeof AdminLokacijeRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/admin/emails": {
      id: "/admin/emails";
      path: "/emails";
      fullPath: "/admin/emails";
      preLoaderRoute: typeof AdminEmailsRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/admin/dashboard": {
      id: "/admin/dashboard";
      path: "/dashboard";
      fullPath: "/admin/dashboard";
      preLoaderRoute: typeof AdminDashboardRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/admin/categories": {
      id: "/admin/categories";
      path: "/categories";
      fullPath: "/admin/categories";
      preLoaderRoute: typeof AdminCategoriesRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/admin/products/": {
      id: "/admin/products/";
      path: "/products";
      fullPath: "/admin/products/";
      preLoaderRoute: typeof AdminProductsIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/admin/orders/": {
      id: "/admin/orders/";
      path: "/orders";
      fullPath: "/admin/orders/";
      preLoaderRoute: typeof AdminOrdersIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/admin/products/new": {
      id: "/admin/products/new";
      path: "/products/new";
      fullPath: "/admin/products/new";
      preLoaderRoute: typeof AdminProductsNewRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/admin/orders/$id": {
      id: "/admin/orders/$id";
      path: "/orders/$id";
      fullPath: "/admin/orders/$id";
      preLoaderRoute: typeof AdminOrdersIdRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/admin/products/$id/edit": {
      id: "/admin/products/$id/edit";
      path: "/products/$id/edit";
      fullPath: "/admin/products/$id/edit";
      preLoaderRoute: typeof AdminProductsIdEditRouteImport;
      parentRoute: typeof AdminRoute;
    };
  }
}

interface AdminRouteChildren {
  AdminCategoriesRoute: typeof AdminCategoriesRoute;
  AdminDashboardRoute: typeof AdminDashboardRoute;
  AdminEmailsRoute: typeof AdminEmailsRoute;
  AdminLokacijeRoute: typeof AdminLokacijeRoute;
  AdminSettingsRoute: typeof AdminSettingsRoute;
  AdminShippingRoute: typeof AdminShippingRoute;
  AdminShippingCredentialsRoute: typeof AdminShippingCredentialsRoute;
  AdminOrdersIdRoute: typeof AdminOrdersIdRoute;
  AdminProductsNewRoute: typeof AdminProductsNewRoute;
  AdminOrdersIndexRoute: typeof AdminOrdersIndexRoute;
  AdminProductsIndexRoute: typeof AdminProductsIndexRoute;
  AdminProductsIdEditRoute: typeof AdminProductsIdEditRoute;
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminCategoriesRoute: AdminCategoriesRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminEmailsRoute: AdminEmailsRoute,
  AdminLokacijeRoute: AdminLokacijeRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminShippingRoute: AdminShippingRoute,
  AdminShippingCredentialsRoute: AdminShippingCredentialsRoute,
  AdminOrdersIdRoute: AdminOrdersIdRoute,
  AdminProductsNewRoute: AdminProductsNewRoute,
  AdminOrdersIndexRoute: AdminOrdersIndexRoute,
  AdminProductsIndexRoute: AdminProductsIndexRoute,
  AdminProductsIdEditRoute: AdminProductsIdEditRoute,
};

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  CartRoute: CartRoute,
  PaymentRoute: PaymentRoute,
  ShippingRoute: ShippingRoute,
  AdminLoginRoute: AdminLoginRoute,
  OrderConfirmationOrderIdRoute: OrderConfirmationOrderIdRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
